export default __webpack_public_path__ + "static/armony-plus-3-a7356d2b2f38850e7149b6e7505f8c2b.jpg";